/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useMemo, useState } from "react";
import { Modal, Input, Table, message, Tag, Tooltip } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import dayjs from "dayjs";
import InvoiceService from "../../../../service/ERP/Invoice.service";

const invService = InvoiceService();

const money = (v) =>
  Number(v || 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });

const invCodeOf = (runno) => (runno ? `NSF${String(runno).padStart(4, "0")}` : "-");

/** เลือก Proforma Invoice ที่จะดึงมาสร้าง Invoice */
export default function ModalPickPI({ open, close, confirm }) {
  const [rows, setRows] = useState([]);
  const [keyword, setKeyword] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!open) return;
    setKeyword("");
    setLoading(true);
    invService
      .availablePI("")
      .then((res) => setRows(res.data?.data || []))
      .catch(() => message.error("โหลดรายการ Proforma Invoice ไม่สำเร็จ"))
      .finally(() => setLoading(false));
  }, [open]);

  const data = useMemo(() => {
    const k = keyword.trim().toLowerCase();
    if (!k) return rows;
    return rows.filter((r) =>
      [r.pi_code, r.cusname, r.brand]
        .filter(Boolean)
        .some((v) => String(v).toLowerCase().includes(k))
    );
  }, [rows, keyword]);

  const columns = [
    {
      title: "เลขที่ PI",
      dataIndex: "pi_code",
      width: 130,
      render: (v, r) =>
        Number(r.is_draft) === 1 ? <Tag color="default">ยังไม่ออกเลข</Tag> : <span>{v}</span>,
    },
    {
      title: "เลข Invoice",
      key: "inv",
      width: 150,
      render: (_, r) =>
        Number(r.inv_reserved) === 1 ? (
          <Tooltip title="จองเลขไว้แล้ว จะได้เลขนี้">
            <Tag color="gold">{invCodeOf(r.runno)}</Tag>
          </Tooltip>
        ) : (
          <Tooltip title="ระบบจะออกเลขให้ทั้ง PI และ Invoice ตอนบันทึก">
            <Tag>ออกเลขใหม่ตอนบันทึก</Tag>
          </Tooltip>
        ),
    },
    {
      title: "วันที่",
      dataIndex: "pi_date",
      width: 110,
      align: "center",
      render: (v) => (v ? dayjs(v).format("DD/MM/YYYY") : "-"),
    },
    { title: "ลูกค้า", dataIndex: "cusname" },
    { title: "Brand", dataIndex: "brand", width: 130 },
    {
      title: "รายการ",
      key: "items",
      width: 150,
      align: "center",
      render: (_, r) =>
        Number(r.unmapped_count) > 0 ? (
          <Tooltip title="ต้องจับคู่รหัสสินค้าก่อนบันทึก Invoice">
            <Tag color="orange">
              {r.item_count} รายการ · ยังไม่จับคู่ {r.unmapped_count}
            </Tag>
          </Tooltip>
        ) : (
          <Tag color="green">{r.item_count} รายการ</Tag>
        ),
    },
    {
      title: "ยอดรวม",
      dataIndex: "total_amount",
      width: 130,
      align: "right",
      render: (v, r) => `${r.currency || ""} ${money(v)}`,
    },
  ];

  return (
    <Modal
      open={open}
      onCancel={() => close?.(false)}
      footer={null}
      width={1020}
      title="เลือก Proforma Invoice"
      destroyOnClose
    >
      <Input
        allowClear
        prefix={<SearchOutlined />}
        placeholder="ค้นหาเลขที่ PI / ลูกค้า / brand"
        value={keyword}
        onChange={(e) => setKeyword(e.target.value)}
        className="!mb-3"
      />
      <Table
        size="small"
        rowKey="pi_code"
        loading={loading}
        columns={columns}
        dataSource={data}
        pagination={{ pageSize: 10, showSizeChanger: false }}
        scroll={{ y: 360 }}
        onRow={(record) => ({
          onClick: () => {
            confirm?.(record);
            close?.(false);
          },
          style: { cursor: "pointer" },
        })}
      />
    </Modal>
  );
}
